module.exports = __webpack_public_path__ + "img/system17.c32aaf83.png";